import { jsx as _jsx } from "react/jsx-runtime";
import { htmlToDraftState } from "@msys/textutils";
import React from "react";
import { convertFromRaw, Editor, EditorState, } from "draft-js";
import { blockRenderMap } from "./blockRenderMap.js";
export const RichTextValue = ({ htmlContent = "", content, style, }) => {
    const editorState = React.useMemo(() => {
        if (content)
            return EditorState.createWithContent(convertFromRaw(content));
        const contentState = htmlToDraftState(htmlContent);
        return EditorState.createWithContent(contentState);
    }, [htmlContent, content]);
    return (_jsx("div", { style: style, children: _jsx(Editor, { editorState: editorState, readOnly: true, onChange: () => { }, blockRenderMap: blockRenderMap }) }));
};
//# sourceMappingURL=RichTextValue.js.map